import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Room} from './room.model';
import {RoomService} from './room.service';
import {RoutePrefix} from '../shared/route-prefix';

@Component({
  selector: 'app-room-datatable',
  templateUrl: './room-datatable.component.html'
})
export class RoomDatatableComponent extends DatatableViewComponent<Room> implements  OnDestroy, OnInit {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Input() public routePrefix: RoutePrefix | RoutePrefix[];

  constructor(
    protected roomService: RoomService,
    private router: UIRouter
  ) {
    super(roomService);
  }

  public ngOnDestroy(): void {
    this.roomService.clearRoutePrefix();
  }

  public ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.roomService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.fetchData();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.roomService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('building.edit.floor.edit.room.edit', { roomId: event.row.id }, { reload: true });
  }}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/room/room-datatable.component.ts